import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IParentInfo } from "src/models/HumanResources/ParentInfos.models";

interface ParentInfoState {
  parentInfos: IParentInfo[];
  parentInfoToEdit: IParentInfo | null;
}

const initialState: ParentInfoState = {
  parentInfos: [],
  parentInfoToEdit: null,
};

const ParentInfoSlice = createSlice({
  name: "ParentInfo",
  initialState,
  reducers: {
    setParentInfoList: (state, action: PayloadAction<IParentInfo[]>) => {
      state.parentInfos = action.payload;
    },
    concatListParentInfo: (
      state: ParentInfoState,
      action: PayloadAction<IParentInfo[]>
    ) => {
      state.parentInfos = [...state.parentInfos.concat(action.payload)];
    },
    setParentInfoToEdit: (state, action: PayloadAction<IParentInfo | null>) => {
      state.parentInfoToEdit = action.payload;
    },
    addParentInfo: (state, action: PayloadAction<IParentInfo>) => {
      // console.log("addParentInfo", action.payload);
      // console.log(
      //   "addParentInfo Before",
      //   state.parentInfos.values
      // );
      // state.parentInfos.push(action.payload);
      // console.log(
      //   "addParentInfo After",
      //   state.parentInfos.values
      // );

      // Crear una copia del array existente y agregar el nuevo item
      const updatedDocuments = [...state.parentInfos, action.payload];

      // Actualizar el estado con la nueva copia del array
      state.parentInfos = updatedDocuments;
    },
    updateParentInfo: (state, action: PayloadAction<IParentInfo>) => {
      let itemIndex = state.parentInfos.findIndex(
        item =>
          item.parentInfoId === action.payload.parentInfoId &&
          item.parentTypeId === action.payload.parentTypeId &&
          item.name === action.payload.name
      );

      if (itemIndex !== -1) state.parentInfos[itemIndex] = action.payload;
    },
    deleteParentInfo: (state, action: PayloadAction<IParentInfo>) => {
      const newArray = state.parentInfos.filter(
        item =>
          !(
            item.documentNumber === action.payload.documentNumber &&
            item.parentTypeId === action.payload.parentTypeId &&
            item.name === action.payload.name
          )
      );
      state.parentInfos = newArray;
    },
  },
});

export const {
  setParentInfoList,
  concatListParentInfo,
  setParentInfoToEdit,
  addParentInfo,
  updateParentInfo,
  deleteParentInfo,
} = ParentInfoSlice.actions;

export default ParentInfoSlice.reducer;
